export default
    {
        MakeBackableForm: (name, cb) => {
            if (typeof window != "undefined") {
                window.history.pushState(null, "", window.location.href);
                document.body.style.overflow = "hidden";
                if (!global.onback) {
                    global.onback = {}
                }
                global.onback[name] = (event: PopStateEvent) => {
                    event.preventDefault();
                    cb();
                    global.onbackremover();
                }

                global.onbackremover = () => {
                    window.history.pushState(null, "", window.location.href);
                    document.body.style.overflowY = "auto";
                    window.removeEventListener("popstate", global.onback[name]);
                }
                window.addEventListener("popstate", global.onback[name]);
            }
        },

        RemoveBackableForms: (name) => {
            // return;
            if (typeof window != "undefined") {
                if (!global.onback) {
                    global.onback = {}
                }
                // window.removeEventListener("popstate", global.onback[name]);
                // window.history.go(-1);
                document.body.style.overflowY = "auto";
            }
        }
    }